function getColumnWidth(name) {
  if (name.length <= 18) return 'm'
  if (name.length > 50) return 'xl'
  return 'l'
}

export default getColumnWidth
